import React from "react";
import { Col, Container, Image, Row } from "react-bootstrap";
import { NavLink } from "react-router-dom";
import Banch1 from "../../../Assets/images/cultured-img/landing-page-img/banch-mark-img/banch1.png";
import Banch2 from "../../../Assets/images/cultured-img/landing-page-img/banch-mark-img/banch2.png";
import Banch3 from "../../../Assets/images/cultured-img/landing-page-img/banch-mark-img/banch3.png";
import Banch4 from "../../../Assets/images/cultured-img/landing-page-img/banch-mark-img/banch4.png";

const BanchmarkCollection = () => {
  return (
    <>
      <div className="wedding_banchmark_collection_Section mt-4">
        <Container className="dfl_custome_container_staticpage ">
          <Row>
            <Col sm={12} md={12} lg={12}>
              <div className="top_heading_metal pt-4">
                <h2>Explore Our Benchmark Collections </h2>
              </div>
            </Col>
          </Row>
          <Row>
            <Col sm={12} md={3} lg={3} className="p-0">
              <div className="cb_banck_img_box">
                <NavLink to="/jewelry/men-wedding-rings-and-bands/style=Tantalum">
                  <Image src={Banch1} alt="Banchmark Image" />
                </NavLink>
              </div>
            </Col>
            <Col sm={12} md={3} lg={3} className="p-0">
              <div className="cb_banck_img_box">
                <NavLink to="/jewelry/men-wedding-rings-and-bands/style=Benchmark%20Classic">
                  <Image src={Banch2} alt="Banchmark Image" />
                </NavLink>
              </div>
            </Col>
            <Col sm={12} md={3} lg={3} className="p-0">
              <div className="cb_banck_img_box">
                <NavLink to="/jewelry/men-wedding-rings-and-bands/style=Forge%20Collection">
                  <Image src={Banch3} alt="Banchmark Image" />
                </NavLink>
              </div>
            </Col>
            <Col sm={12} md={3} lg={3} className="p-0">
              <div className="cb_banck_img_box">
                <NavLink to="/jewelry/men-wedding-rings-and-bands/style=Benchmark%20Designs">
                  <Image src={Banch4} alt="Banchmark Image" />
                </NavLink>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};

export default BanchmarkCollection;
